var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.initData)?_c('router-view',{attrs:{"init-data":_vm.initData}}):_c('v-container',[(_vm.loading)?_c('v-progress-linear',{attrs:{"indeterminate":"","color":"secondary"}}):_vm._e(),(_vm.error)?_c('v-alert',{attrs:{"type":"error","outlined":"","dense":""}},[_vm._v(" Ошибка получения экспертизы: "+_vm._s(_vm.error)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }